import React from 'react';
import Link from 'next/link'
import { ViewListIcon } from "../vectors/ViewListIcon";
import IndividualTileBadge from "../Search/IndividualTileBadge";

const IndividualTilesServices = ({ services, permalink, handleGTM }) => {
    const servicesCount = services.length
    const servicesLeft = Math.max(servicesCount - 4, 0)

    return (
        <>
            <IndividualTileBadge
                label='Services offered:'
                icon={<ViewListIcon />}
            />

            <div className='text-sm'>
                {services.slice(0, 4).map(({name, key}) =>
                    <p key={`service-${key}`} className='pl-8 p-0 m-0'>
                        {name}
                    </p>
                )}

                {servicesLeft > 0 &&
                    <Link href={permalink}>
                        <a className='pl-8' onClick={() => handleGTM('services more')}>
                            + {servicesLeft} more
                        </a>
                    </Link>
                }
            </div>
        </>
    )
}

export default IndividualTilesServices